<template>
  <div class="main-content">
    <div class="h2"><strong>發送驗證信</strong></div>
    <div class="subtitle">
      想起您的密碼嗎？
      <a href="#" @click="$store.commit('setLoginCurrentContent', 'login')">帳戶登入</a>
    </div>
    <div class="form-div">
      <input type="email" class="form-input" id="user-email" placeholder=" " v-model.lazy="reset_password.email">
      <label for="user-email" class="form-label">使用者電子信箱</label>
    </div>
    <div class="send-bag">
      <div id="error-password" class="text-danger"></div>
      <button class="form-button bg-success" @click="sentMail">發送驗證信</button>
    </div>
    <hr>
    <div class="login-logo">
      <img :src="base_url + '/images/logo.png'" alt="">
    </div>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [validation, axiosMixins],
  data() {
    return {
      base_url: base_url,
      reset_password: {
        email: ''
      },
    }
  },
  methods: {
    sentMail() {
      if (!this.validateBeforeSubmit()) { return }
      const error_element = this.$el.querySelector('#error-password')
      const axios_data = { account: this.reset_password.email };
      axios.post(base_url + '/api/verify/request-verification', axios_data)
        .then((response) => {
          if (response.data.status === "success") {
            this.$store.commit('setLoginCurrentContent', 'enter-token')
          } else {
            error_element.innerHTML = "驗證系統忙碌，請稍後再試";
          }
        }).catch((error) => {
          this.axiosMessage(error);
          error_element.innerHTML = "帳號或密碼錯誤";
        });

      setTimeout(() => {
        if (error_element.innerHTML !== "") {
          error_element.innerHTML = "";
        }
      }, 3000);
    }
  },
  components: { CopyrightComponent },
}
</script>
